<template>
  <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="tolast()">
          <span class="icon icon-left"></span>返回
        </a>
      </nav>

    <div class="content" style="margin-bottom: 3rem">
      <div class="content-block-title">{{member.customerPlanName}}成员信息</div>
      <div class="list-block">
        <ul style="margin-left: 10px;margin-right: 10px">
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">身份</div>
              <div class="item-title" v-if="member.role === 1">储值联系人</div>
              <div class="item-title" v-else-if="member.role === 2">积分联系人</div>
              <div class="item-title" v-else-if="member.role === 3">管理联系人</div>
              <div class="item-title" v-else-if="member.role === 4">对账联系人</div>
              <div class="item-title" v-else-if="member.role === 5">普通成员</div>
              <div class="item-title" v-else>未知</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">姓名</div>
              <div class="item-title">{{member.customerPlanMemberName}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">编号</div>
              <div class="item-title">{{member.customerPlanMemberNo}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">大客户计划编号</div>
              <div class="item-title">{{member.customerPlanNo}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">单位</div>
              <div class="item-title">{{member.enterpriseName}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">电话</div>
              <div class="item-title">{{member.mobile}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">是否禁用</div>
              <div class="item-title" v-if="member.availableFlag === 1">否</div>
              <div class="item-title" v-else>否</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">加入时间</div>
              <div class="item-title" v-if="member.availableFlag === 1">{{member.joinPlanDt}}</div>
            </div>
          </li>
          <li class="item-content">
            <div class="item-inner">
              <div class="item-title">有效截止时间</div>
              <div class="item-title" v-if="member.availableFlag === 1">{{member.overdueDt}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
//  import $ from 'jquery'
  import {mapState} from 'vuex'
  export default {
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    data () {
      return {
        member: {}
      }
    },
    methods: {
      fetchData () {
        this.member = this.$route.query.member
        console.log(this.member)
      },
      tolast () {
        this.$router.push({path: 'VipPlanMemberDetails', query: {plan: this.$route.query.plan}})
      },
      gotovipdetails () {
        console.log(1)
      }
    }
  }
</script>


<style scoped>
  .item-inner {
    padding-bottom: 0rem
  }
</style>



// WEBPACK FOOTER //
// memberDetails.vue?29e6a0f2